import api from "@/api";

import BargeLogisticMonitoring from "../../views/performanceCostAnalysis/costAnalysis/components/BargeLogisticMonitoring.vue";

const namespaced = true

const state = {
  majorAssumptions: [],
  logisticCost3rdPartyCoal: [],
  bargeLogisticTargetMonitoring: {},
  logisticCostPerActivity: {},
  totalLogisticCost: {}
}

const getters = {
  majorAssumptions: (state) => state.majorAssumptions,
  logisticCost3rdPartyCoal: (state) => state.logisticCost3rdPartyCoal,
  bargeLogisticTargetMonitoring: (state) => state.bargeLogisticTargetMonitoring,
  logisticCostPerActivity: (state) => state.logisticCostPerActivity,
  totalLogisticCost: (state) => state.totalLogisticCost
}

const mutations = {
  SET_MAJOR_ASSUMPTIONS: (state, payload) => {
    state.majorAssumptions = payload
  },
  SET_LOGISTIC_COST_3RD_PARTY_COAL: (state, payload) => {
    state.logisticCost3rdPartyCoal = payload
  },
  SET_BARGE_LOGISTIC_TARGET_MONITORING: (state, payload) => {
    state.bargeLogisticTargetMonitoring = payload
  },
  SET_LOGISTIC_COST_PER_ACTIVITY: (state, payload) => {
    state.logisticCostPerActivity = payload
  },
  SET_TOTAL_LOGISTIC_COST: (state, payload) => {
    state.totalLogisticCost = payload
  }
}

const actions = {
  async fetchMajorAssumptions({ commit }, payload) {
    try {
      const { data } = await api.getMajorAssumptions(payload)
      if (data.error) {
        commit('SET_MAJOR_ASSUMPTIONS', [])
        return
      }

      commit('SET_MAJOR_ASSUMPTIONS', data)
    } catch (err) {
      throw err
    }
  },
  async fetchLogisticCost3rdPartyCoal({ commit }, payload) {
    try {
      const { data } = await api.getLogisticCost3rdPartyCoal(payload)
      if (data.error) {
        commit('SET_LOGISTIC_COST_3RD_PARTY_COAL', [])
        return
      }

      commit('SET_LOGISTIC_COST_3RD_PARTY_COAL', data)
    } catch (err) {
      throw err
    }
  },
  async fetchBargeLogisticTargetMonitoring({ commit }, payload) {
    try {
      const { data } = await api.getBargeLogisticTargetMonitoring(payload)
      if (data.error) {
        commit('SET_BARGE_LOGISTIC_TARGET_MONITORING', {})
        return
      }

      commit('SET_BARGE_LOGISTIC_TARGET_MONITORING', data)
    }catch(err) {
      throw err
    }
  },
  async fetchLogisticCostPerActivity({ commit }, payload) {
    try {
      const { data } = await api.getLogisticCostPerActivity(payload)
      if (data.error) {
        commit('SET_LOGISTIC_COST_PER_ACTIVITY', {})
        return
      }

      commit('SET_LOGISTIC_COST_PER_ACTIVITY', data)
    }
    catch (err) {
      throw err
    }
  },
  async fetchTotalLogisticCost({ commit }, payload) {
    try {
      const { data } = await api.getTotalLogisticCost(payload)
      if (data.error) {
        commit('SET_TOTAL_LOGISTIC_COST', {})
        return
      }
      commit('SET_TOTAL_LOGISTIC_COST', data)
    }
    catch (err) {
      throw err
    }
  }
}

export default { namespaced, state, getters, mutations, actions }